export default __webpack_public_path__ + "static/media/home-interactive-portfolio-img-05.814f35c4.jpg";